import styled from "@emotion/styled"
import { Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import Button from "components/Button"
import IconButton from "components/IconButton"
import { EllipsisCSS } from "components/Ellipsis/style"
import { TAP_BAR_HEIGHT, TAP_BAR_MEDIA_QUERY_DOWN } from "components/TapBar/style"
import { docketTheme } from "theme"
import { buttonsStatesColors } from "theme/Button/constants"
import Image from "../../../components/Image"

export const AppMain = styled.div`
  position: relative;
  min-width: 0; /* Prevents flex child stretching out of its container */
  background-color: ${docketTheme.colors.background};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  ${({ theme }) => theme.breakpoints.down(TAP_BAR_MEDIA_QUERY_DOWN)} {
    /* Because just adding padding-bottom does not work in Firefox */
    height: ${`calc(100% - ${TAP_BAR_HEIGHT})`};
    margin-bottom: ${TAP_BAR_HEIGHT};
  }
`

export const StyledUserContainerGrid = styled(Grid)`
  height: 7rem;
  margin-top: 0;
  margin-bottom: 0;
`

export const StyledPracticeLogoNameWrapper = styled.div`
  align-items: center;
  display: flex;
  overflow: hidden;
  flex: 1;
  margin-left: 3rem;
  line-height: 1.2;
`

export const StyledPracticeNameTitle = styled(Typography)`
  ${EllipsisCSS}
` as typeof Typography

export const StyledPracticeLogoImage = styled(Image)`
  margin-right: 1.5rem;
  display: block;
  height: 3rem;
  width: auto;
`

export const StyledAvatarButton = styled(IconButton)`
  color: ${({ theme }) => theme.palette.common.white};
  ${buttonsStatesColors.noBackgroundLight};
`

export const StyledLogoutButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.common.white};
`
